import { BackOfficePrivilegeName } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { useUserPermission } from '@hooks/useUserPermission'

/** Either privilege grants access to the stay inbox (Guest Inbox board and stay timelines). */
export const STAY_INBOX_PRIVILEGES = [
  BackOfficePrivilegeName.stayInboxRead,
  BackOfficePrivilegeName.stayInboxWrite,
]

interface StayInboxPermission {
  /** Can open the Guest Inbox board and a stay's timeline. Write implies read. */
  canReadStayInbox: boolean
  /** Can message the guest from a stay's timeline. */
  canWriteStayInbox: boolean
}

export const useStayInboxPermission = (): StayInboxPermission => {
  const canWriteStayInbox = useUserPermission({
    privilegeName: BackOfficePrivilegeName.stayInboxWrite,
  })
  const hasReadPrivilege = useUserPermission({
    privilegeName: BackOfficePrivilegeName.stayInboxRead,
  })

  return {
    canReadStayInbox: hasReadPrivilege || canWriteStayInbox,
    canWriteStayInbox,
  }
}
